<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">车位区域：</span>
        </div>
        <el-select v-model="areaCode"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请选择车位区域">
          <el-option v-for="item in parkingLotAreaList" :key="item.code"
                     :label="item.parkingLotAreaName" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">车位号：</span>
        </div>
        <el-select v-model="parkingLotCode"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod2"
                   placeholder="请选择车位号">
          <el-option v-for="item in parkingLotList" :key="item.code"
                     :label="item.parkLotNumber" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <!-- <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">租赁人：</span>
        </div>
        <el-input v-model="formData.personName" size="small" style="width: 280px" />
      </div> -->

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">手机号：</span>
        </div>
        <el-input v-model="formData.personPhone" size="small" style="width: 280px" />
      </div>

    <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">车牌号：</span>
        </div>
        <el-input v-model="formData.carNumber" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">选择缴费方式：</span>
        </div>
        <el-select
          v-model="paymentCode"
          filterable
          remote
          reserve-keyword
          placeholder="请选择缴费方式"
          size="small" style="width:280px"
          :remote-method="paymentRemoteMethod"
           >
           <el-option
            v-for="item in paymentList"
            :key="item.code"
            :label="item.paymentCycleName"
            :value="item.code"
            >
           </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">起始日期：</span>
        </div>
          <el-date-picker v-model="formData.leaseStartTime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" size="small" @change="changeEnterStartDate()" style="width: 280px"></el-date-picker>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">结束日期：</span>
        </div>
          <el-date-picker disabled v-model="formData.leaseStopTime" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" size="small" @change="changeEnterEndDate()" style="width: 280px"></el-date-picker>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">附件：</span>
        </div>
      <input id="upload" name="file" accept="image/*" type="file"
             @change="upData" style="display: none;" />
      <a @click="upImg" class="photoBox" style="position:relative">
        <p class="add" v-if="!formData.annexUrl">✚</p>
        <img :src="formData.annexUrl" id="peopleImg" class="img" v-if="formData.annexUrl" />
      </a>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import md5 from "js-md5";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { api } from "../../api/ParkingService";
import { errorHandler } from "../../../utils/errorHandler";
import { nError, nSuccess } from "../../../utils/notice";
import { pattern } from "../../../utils/regular";

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "parking-lot-add-one",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "车位租赁"
        }
      ],
      mainTitle: "添加车位",
      subheading: "",

      typeList: [{ code: "true", name: "是" }, { code: "false", name: "否" }],
      formData: {
        parkLotNumber: "",
        fix: "",
        leaseStartTime: "",
        leaseStopTime: "",
        annexUrl: ""
      },
      areaCode: "",
      paymentCode: "",
      parkingLotAreaList: [],
      paymentList: [],
      parkingLotCode: "",
      parkingLotList: []
    };
  },
  created() {
    this.remoteMethod();
    this.remoteMethod2();
    this.paymentRemoteMethod();

    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let strDate = date.getDate();

    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }

    let oneYearLateYear = year + 1;
    let oneYearLateMonth = month;
    let oneYearLateDate = "";
    if (strDate > 1) {
      oneYearLateDate = strDate - 1;
    } else {
      oneYearLateMonth = month - 1;
      if (oneYearLateMonth < 10) {
        oneYearLateMonth = "0" + oneYearLateMonth;
      }
      if (oneYearLateMonth === 0) {
        oneYearLateMonth = 12;
        oneYearLateYear = year;
      }
      oneYearLateDate = new Date(
        oneYearLateYear,
        oneYearLateMonth,
        0
      ).getDate();
    }
    if (oneYearLateDate >= 0 && oneYearLateDate <= 9) {
      oneYearLateDate = "0" + oneYearLateDate;
    }
    this.formData.leaseStartTime = `${year}-${month}-${strDate}`;
    this.formData.leaseStopTime = `${oneYearLateYear}-${oneYearLateMonth}-${oneYearLateDate}`;
  },
  methods: {
    remoteMethod() {
      this.getParkingLotAreaList();
    },
    getParkingLotAreaList() {
      this.$axios
        .post(api.getParkingLotAreaList, {})
        .then(res => {
          this.parkingLotAreaList = res.data.data;
        })
        .catch(errorHandler("获取车位区域列表失败"));
    },
    changeEnterStartDate() {
      this.changePickerOptions1();
    },
    changeEnterEndDate() {
      this.changePickerOptions2();
    },
    changePickerOptions1() {
      let leaseStartTime =
        new Date(this.formData.leaseStartTime).getTime() - 3600 * 24 * 1000;
      this.pickerOptions1 = {
        disabledDate(time) {
          return time.getTime() < leaseStartTime;
        }
      };
    },
    changePickerOptions2() {
      let leaseStopTime = new Date(this.formData.leaseStopTime).getTime();
      this.pickerOptions2 = {
        disabledDate(time) {
          return time.getTime() > leaseStopTime;
        }
      };
    },
    remoteMethod2() {},
    getParkingLotList() {
      this.$axios
        .get(api.getParkingLotList + "/" + this.formData.parkingLotAreaCode, {})
        .then(res => {
          this.parkingLotList = res.data.data;
        })
        .catch(errorHandler("获取车位信息失败"));
    },
    // 确认添加
    confirm() {
      // this.formData.annexUrl =
      //   "https://damai-parking.oss-cn-hangzhou.aliyuncs.com/pic/20210916170142/57009e77bc4348dcbc007ba43b61c14c.png";
      if (!this.formData.parkingLotAreaCode) {
        nError("请选择车位区域");
        return false;
      }
      if (!this.formData.parkingLotCode) {
        nError("请选择车位号");
        return false;
      }
      if (!this.formData.personPhone) {
        nError("请输入手机号");
        return false;
      }
      if (!this.formData.carNumber) {
        nError("请输入车牌号");
        return false;
      }
      if (!this.formData.paymentConfigCode) {
        nError("请选择缴费方式");
        return false;
      }
      this.$axios
        .post(api.addParkingLeaseByAdmin, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("添加成功");
            this.$router.push({
              name: "parking-rent"
            });
          }
        })
        .catch(errorHandler());
    },
    cancel() {
      this.$router.push({
        name: "parking-rent"
      });
    },
    changeTime() {
      if (this.formData.paymentMethod == "1") {
        let nowDate = new Date(this.formData.leaseStartTime);
        let yyyy = nowDate.getFullYear();
        let mm =
          nowDate.getMonth() + 1 < 10
            ? "0" + (nowDate.getMonth() + 1)
            : nowDate.getMonth() + 1;
        let dd =
          nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
        let leaseStartTime = `${yyyy}-${mm}-${dd}`;
        let YYYY = "";
        let MM = "";
        let DD = "";
        if (mm == 12) {
          YYYY = yyyy + 1;
          MM = "01";
        } else {
          YYYY = yyyy;
          MM = +mm + 1 < 10 ? "0" + (+mm + 1) : +mm + 1;
        }
        if (dd == "01") {
          if (
            mm == "01" ||
            mm == "03" ||
            mm == "05" ||
            mm == "07" ||
            mm == "08" ||
            mm == "10" ||
            mm == "12"
          ) {
            DD = "31";
          } else if (mm == "02") {
            if (yyyy % 4 == 0 || yyyy % 400 == 0) {
              DD = "29";
            } else {
              DD = "28";
            }
          } else {
            DD = "30";
          }
        } else {
          DD = dd - 1;
        }
        if ((mm == "01" && dd == "31" && yyyy % 4 == 0) || yyyy % 400 == 0) {
          YYYY = yyyy;
          MM = "03";
          DD = "01";
        } else if (mm == "01" && dd == "31" && yyyy % 4 != 0) {
          YYYY = yyyy;
          MM = "03";
          DD = "02";
        }
        if ((mm == "01" && dd == "30" && yyyy % 4 == 0) || yyyy % 400 == 0) {
          YYYY = yyyy;
          MM = "02";
          DD = "29";
        } else if (mm == "01" && dd == "30" && yyyy % 4 != 0) {
          YYYY = yyyy;
          MM = "03";
          DD = "01";
        }
        DD = DD < 10 ? "0" + DD : DD;
        let leaseStopTime = `${YYYY}-${MM}-${DD}`;
        this.formData.leaseStopTime = leaseStopTime;
      } else if (this.formData.paymentMethod == "2") {
        let nowDate = new Date(this.formData.leaseStartTime);
        let yyyy = nowDate.getFullYear();
        let mm =
          nowDate.getMonth() + 1 < 10
            ? "0" + (nowDate.getMonth() + 1)
            : nowDate.getMonth() + 1;
        let dd =
          nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
        let leaseStartTime = `${yyyy}-${mm}-${dd}`;
        let dt = new Date(yyyy, mm - 1, dd);
        dt.setMonth(dt.getMonth() + 3);
        dt.setDate(dt.getDate() - 1);
        let yyyy2 = dt.getFullYear();
        let mm2 =
          dt.getMonth() + 1 < 10
            ? "0" + (dt.getMonth() + 1)
            : dt.getMonth() + 1;
        let dd2 = dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate();
        let leaseStopTime = `${yyyy2}-${mm2}-${dd2}`;
        this.formData.leaseStopTime = leaseStopTime;
      } else if (this.formData.paymentMethod == "3") {
        let nowDate = new Date(this.formData.leaseStartTime);
        let yyyy = nowDate.getFullYear();
        let mm =
          nowDate.getMonth() + 1 < 10
            ? "0" + (nowDate.getMonth() + 1)
            : nowDate.getMonth() + 1;
        let dd =
          nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
        let leaseStartTime = `${yyyy}-${mm}-${dd}`;
        let dt = new Date(yyyy, mm - 1, dd);
        dt.setMonth(dt.getMonth() + 6);
        dt.setDate(dt.getDate() - 1);
        let yyyy2 = dt.getFullYear();
        let mm2 =
          dt.getMonth() + 1 < 10
            ? "0" + (dt.getMonth() + 1)
            : dt.getMonth() + 1;
        let dd2 = dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate();
        let leaseStopTime = `${yyyy2}-${mm2}-${dd2}`;
        this.formData.leaseStopTime = leaseStopTime;
      } else if (this.formData.paymentMethod == "4") {
        let nowDate = new Date(this.formData.leaseStartTime);
        let yyyy = nowDate.getFullYear();
        let mm =
          nowDate.getMonth() + 1 < 10
            ? "0" + (nowDate.getMonth() + 1)
            : nowDate.getMonth() + 1;
        let dd =
          nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
        let leaseStartTime = `${yyyy}-${mm}-${dd}`;
        let dt = new Date(yyyy, mm - 1, dd);
        dt.setMonth(dt.getMonth() + 12);
        dt.setDate(dt.getDate() - 1);
        let yyyy2 = dt.getFullYear();
        let mm2 =
          dt.getMonth() + 1 < 10
            ? "0" + (dt.getMonth() + 1)
            : dt.getMonth() + 1;
        let dd2 = dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate();
        let leaseStopTime = `${yyyy2}-${mm2}-${dd2}`;
        this.formData.leaseStopTime = leaseStopTime;
      }
    },
    paymentRemoteMethod(query) {
      this.$axios
        .post(api.getParkingPaymentConfigList, {
          searchKey: query,
          configType: 4
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            data.map(v => {
              if (v.paymentCycle === "1") {
                v.paymentCycleName = "月缴";
              } else if (v.paymentCycle === "2") {
                v.paymentCycleName = "季缴";
              } else if (v.paymentCycle === "3") {
                v.paymentCycleName = "半年缴";
              } else {
                v.paymentCycleName = "年缴";
              }
            });
            this.paymentList = data;
          }
        })
        .catch(errorHandler("获取缴费列表失败"));
    },
    upData() {
      const that = this;
      const oFReader = new FileReader();
      const file = document.getElementById("upload").files[0];
      oFReader.readAsDataURL(file);
      oFReader.onloadend = function(oFRevent) {
        const src = oFRevent.target.result;
        $("#peopleImg").attr("src", src);
        that.formData.annexUrl = src;
      };
    },
    upImg() {
      $("#upload")
        .click() // 隐藏了input:file样式后，点击头像就可以本地上传
        .on("change", function() {
          const objUrl = getObjectURL(this.files[0]); // 获取图片的路径，该路径不是图片在本地的路径
          if (objUrl) {
            $("#peopleImg").attr("src", objUrl); // 将图片路径存入src中，显示出图片
            window.sessionStorage.setItem("img", objUrl);
          }
        });
    }
  },
  watch: {
    areaCode(val) {
      this.parkingLotAreaList.map(v => {
        if (v.code == val) {
          this.formData.parkingLotArea = v.parkingLotAreaName;
          this.formData.parkingLotAreaCode = v.code;
          this.getParkingLotList();
        }
      });
    },
    paymentCode(val) {
      this.paymentList.map(v => {
        if (v.code === val) {
          this.formData.paymentConfigCode = v.code;
          this.formData.paymentCycle = v.paymentCycle;
          this.formData.paymentMethod = v.paymentCycle;
          this.changeTime();
        }
      });
    },
    parkingLotCode(val) {
      this.parkingLotList.map(v => {
        if (v.code == val) {
          this.formData.parkLotNumber = v.parkLotNumber;
          this.formData.parkingLotCode = v.code;
        }
      });
    },
    "formData.leaseStartTime"(val) {
      this.changeTime();
    }
  }
};
function getObjectURL(file) {
  let url = null;
  if (window.createObjectURL !== undefined) {
    // basic
    url = window.createObjectURL(file);
  } else if (window.URL !== undefined) {
    // mozilla(firefox)
    url = window.URL.createObjectURL(file);
  } else if (window.webkitURL !== undefined) {
    // webkit or chrome
    url = window.webkitURL.createObjectURL(file);
  }
  return url;
}
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
}
.form-line {
  margin: 20px 0;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
</style>

<style lang="less" scoped>
.photoBox {
  width: 160px;
  height: 120px;
  border: 1px dashed #dcdfe6;
  border-radius: 5px;
}
.add {
  font-size: 36px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.img {
  width: 160px;
  height: 120px;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingRent/ParkingRentAdd.vue